'use client';

import { Password } from '@petsmart-ui/sparky';
import { useField, useFormikContext } from 'formik';
import type { ReactElement } from 'react';
import { useEffect } from 'react';

import type { SignInFormValues } from './types';

export function PasswordField({ isFormHidden, uniqueId }: { isFormHidden?: boolean; uniqueId: string }): ReactElement {
    const { setFieldValue, setFieldTouched } = useFormikContext<SignInFormValues>();
    const [{ value, onChange, onBlur }, { touched, error }] = useField('password');

    useEffect(() => {
        if (isFormHidden) {
            setFieldValue('password', '');
            setFieldTouched('password', false);
        }
    }, [isFormHidden]);

    return (
        <div data-testid={`${uniqueId}-field`}>
            <Password
                data-cs-mask
                data-testid={uniqueId}
                id={uniqueId}
                label="Password"
                name="password"
                onChange={onChange}
                onBlur={onBlur}
                isError={touched && !!error}
                fieldNote={touched ? error : ''}
                value={value}
            />
        </div>
    );
}
